import {agentFinderAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {AgentDetailsResponse} from '../types'

export const agentDetailsRoute = agentFinderAppBuilder.createQueryRouteConfig('agentDetailsRoute', {
  path: '/agentfinder/*',
  queries: [
    mainQuery<AgentDetailsResponse>({
      queryDeps: ({pathname, params}) => {
        const name = (params as Record<'*', string>)['*']
        return {pathname, name}
      },
    }),
  ],
})
